import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import LayoutSiaLearner from '../../../Shared/Layout/LayoutSiaLearner'
import { SIA_NAVY, SIA_GOLD_ACTIVE_BG } from '../../../constants/siaTheme'

function DownloadIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 3v10.17l-3.88-3.88L6 11l6 6 6-6-1.12-1.12L13 13.17V3h-2zm-6 16v2h14v-2H5z" />
        </svg>
    )
}

const LeadersCatalog = ({ materials }) => {
    return (
        <>
            <div
                className="rounded-3 mb-6 py-5 px-4 text-center text-white text-uppercase fw-bold fs-2 lh-sm shadow-sm"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.06em' }}
            >
                Convierte en un líder
            </div>

            <p className="text-center text-gray-800 fw-semibold fs-5 mb-10 px-2">
                Aprende todo sobre la Cédula &quot;A&quot;
            </p>

            <Row className="g-6 g-lg-8 mb-15 justify-content-center">
                {materials.length === 0 && (
                    <Col xs={12}>
                        <p className="text-center text-muted py-15">Pronto publicaremos el material de Cédula A.</p>
                    </Col>
                )}
                {materials.map((m) => (
                    <Col key={m.id} xs={12} sm={6} md={6} lg={4} xl={3}>
                        <Card className="h-100 shadow-sm border border-gray-200 overflow-hidden rounded-3">
                            <Card.Body className="text-center py-8 px-5 flex-grow-1 d-flex flex-column justify-content-center">
                                <Card.Title className="fs-5 fw-bold text-gray-900 lh-sm mb-0">{m.title}</Card.Title>
                            </Card.Body>
                            <div className="bg-light py-3 px-2 text-center border-top">
                                {m.has_download ? (
                                    <a
                                        href={route('sia.capacitacion.lideres.download', m.id)}
                                        className="d-inline-flex align-items-center justify-content-center rounded-1 text-decoration-none"
                                        style={{ backgroundColor: SIA_GOLD_ACTIVE_BG, width: '42px', height: '42px' }}
                                        title="Descargar"
                                    >
                                        <DownloadIcon />
                                    </a>
                                ) : (
                                    <span className="text-muted small">Sin archivo</span>
                                )}
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </>
    )
}

LeadersCatalog.layout = (page) => <LayoutSiaLearner title="Cédula A | SIA">{page}</LayoutSiaLearner>

export default LeadersCatalog
